class SimpleAccordion extends HTMLElement {
  constructor () {
    super()
    this.isOpen = this.hasAttribute('data-open')
  }

  connectedCallback () {
    this.setupAccordion()
    this.attachEventListeners()
  }

  setupAccordion () {
    this.trigger = this.querySelector('[data-accordion-trigger]')

    if (!this.trigger) {
      console.warn('SimpleAccordion: Missing trigger element')
      return
    }

    // Set initial ARIA attributes
    const triggerId =
      this.trigger.id ||
      `accordion-trigger-${Math.random()
        .toString(36)
        .substr(2, 9)}`
    this.trigger.id = triggerId

    this.trigger.setAttribute('aria-expanded', this.isOpen.toString())

    // Apply state to the accordion element itself
    if (this.isOpen) {
      this.classList.add('is-open')
    } else {
      this.classList.add('is-closed')
    }

    this.trigger.setAttribute('role', 'button')
    this.trigger.setAttribute('tabindex', '0')
  }

  attachEventListeners () {
    if (!this.trigger) return

    // Click handler
    this.trigger.addEventListener('click', () => this.toggle())

    // Keyboard handler (Enter and Space)
    this.trigger.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        this.toggle()
      }
    })
  }

  toggle () {
    this.isOpen = !this.isOpen

    if (this.isOpen) {
      this.open()
    } else {
      this.close()
    }

    // Dispatch custom event for external listeners
    this.dispatchEvent(
      new CustomEvent('accordion-toggle', {
        detail: { isOpen: this.isOpen },
        bubbles: true,
        composed: true,
      }),
    )
  }

  open () {
    this.isOpen = true
    this.classList.remove('is-closed')
    this.classList.add('is-open')
    this.trigger.setAttribute('aria-expanded', 'true')
    this.setAttribute('data-open', '')
  }

  close () {
    this.isOpen = false
    this.classList.remove('is-open')
    this.classList.add('is-closed')
    this.trigger.setAttribute('aria-expanded', 'false')
    this.removeAttribute('data-open')
  }
}

customElements.define('simple-accordion', SimpleAccordion)
